"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const drawable_1 = require("./drawable");
/**
 * The class AbstractGrid is abstract and extends the Drawable interface.
 * - used for storing position of drawable object (nodes, edges etc.)
 * - Defines scaling dimensions to scale the size of drawable object in respect to screen size.
 */
class AbstractGrid extends drawable_1.Drawable {
    constructor() {
        super(42);
        this.resize = () => {
            this.onResize();
        };
        window.addEventListener('resize', this.resize);
    }
}
exports.AbstractGrid = AbstractGrid;
AbstractGrid.GRID_PRIORITY = 42;
